import { render, staticRenderFns } from "./MultiTabs.vue?vue&type=template&id=2d1b7842&scoped=true&"
import script from "./MultiTabs.vue?vue&type=script&lang=js&"
export * from "./MultiTabs.vue?vue&type=script&lang=js&"
import style0 from "./MultiTabs.vue?vue&type=style&index=0&id=2d1b7842&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1b7842",
  null
  
)

export default component.exports